import React, { useEffect, useState, lazy } from 'react';
import { MailIcon, LinkedinIcon, GithubIcon, PhoneIcon, MapPinIcon } from 'lucide-react';
import ContactForm from '../components/ContactForm';
const ContactPage: React.FC = () => {
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    // Simulate content loading
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 800);
    return () => clearTimeout(timer);
  }, []);
  if (isLoading) {
    return <div className="flex items-center justify-center min-h-screen bg-slate-50" data-id="element-300">
        <div className="animate-pulse flex flex-col items-center" data-id="element-301">
          <div className="h-12 w-12 rounded-full bg-primary-300 mb-4" data-id="element-302"></div>
          <div className="h-4 w-48 bg-gray-200 rounded mb-2" data-id="element-303"></div>
          <div className="h-3 w-32 bg-gray-200 rounded" data-id="element-304"></div>
        </div>
      </div>;
  }
  return <div className="bg-slate-50 w-full" data-id="element-305">
      {/* Hero Section */}
      <section className="bg-white" data-id="element-306">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24" data-id="element-307">
          <div className="text-center animate-fade-in" data-id="element-308">
            <h1 className="text-3xl md:text-4xl font-bold text-gray-900" data-id="element-309">
              Get In Touch
            </h1>
            <p className="mt-4 text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-310">
              I'm currently exploring new opportunities where I can leverage my
              product leadership experience to drive meaningful results.
            </p>
          </div>
        </div>
      </section>
      {/* Contact Info & Form Section */}
      <section className="py-16" data-id="element-311">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-312">
          <div className="grid md:grid-cols-2 gap-12" data-id="element-313">
            {/* Contact Info */}
            <div className="animate-fade-in" data-id="element-314">
              <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-315">
                Contact Information
              </h2>
              <div className="bg-white rounded-lg shadow-md p-6 mb-6" data-id="element-316">
                <div className="space-y-4" data-id="element-317">
                  <div className="flex items-start" data-id="element-318">
                    <div className="flex-shrink-0 h-10 w-10 rounded-full bg-primary-100 flex items-center justify-center text-primary-600" data-id="element-319">
                      <MailIcon className="h-5 w-5" data-id="element-320" />
                    </div>
                    <div className="ml-4" data-id="element-321">
                      <h3 className="text-lg font-medium text-secondary-900" data-id="element-322">
                        Email
                      </h3>
                      <a href="mailto:mohitvoid@gmail.com" className="text-primary-600 hover:text-primary-800" data-id="element-323">
                        mohitvoid@gmail.com
                      </a>
                    </div>
                  </div>
                  <div className="flex items-start" data-id="element-324">
                    <div className="flex-shrink-0 h-10 w-10 rounded-full bg-blue-100 flex items-center justify-center text-blue-600" data-id="element-325">
                      <LinkedinIcon className="h-5 w-5" data-id="element-326" />
                    </div>
                    <div className="ml-4" data-id="element-327">
                      <h3 className="text-lg font-medium text-gray-900" data-id="element-328">
                        LinkedIn
                      </h3>
                      <a href="https://www.linkedin.com/in/mohitpole/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-800" data-id="element-329">
                        linkedin.com/in/mohitpole/
                      </a>
                    </div>
                  </div>
                  <div className="flex items-start" data-id="element-330">
                    <div className="flex-shrink-0 h-10 w-10 rounded-full bg-blue-100 flex items-center justify-center text-blue-600" data-id="element-331">
                      <GithubIcon className="h-5 w-5" data-id="element-332" />
                    </div>
                    <div className="ml-4" data-id="element-333">
                      <h3 className="text-lg font-medium text-gray-900" data-id="element-334">
                        GitHub
                      </h3>
                      <a href="https://github.com/mohitpole" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-800" data-id="element-335">
                        github.com/mohitpole
                      </a>
                    </div>
                  </div>
                  <div className="flex items-start" data-id="element-336">
                    <div className="flex-shrink-0 h-10 w-10 rounded-full bg-blue-100 flex items-center justify-center text-blue-600" data-id="element-337">
                      <PhoneIcon className="h-5 w-5" data-id="element-338" />
                    </div>
                    <div className="ml-4" data-id="element-339">
                      <h3 className="text-lg font-medium text-gray-900" data-id="element-340">
                        Phone
                      </h3>
                      <a href="tel:+19374091223" className="text-blue-600 hover:text-blue-800" data-id="element-341">
                        +1 (937) 409-1223
                      </a>
                    </div>
                  </div>
                  <div className="flex items-start" data-id="element-342">
                    <div className="flex-shrink-0 h-10 w-10 rounded-full bg-blue-100 flex items-center justify-center text-blue-600" data-id="element-343">
                      <MapPinIcon className="h-5 w-5" data-id="element-344" />
                    </div>
                    <div className="ml-4" data-id="element-345">
                      <h3 className="text-lg font-medium text-gray-900" data-id="element-346">
                        Location
                      </h3>
                      <p className="text-gray-600" data-id="element-347">
                        Raleigh - Durham, North Carolina
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-348">
                Availability
              </h2>
              <div className="bg-white rounded-lg shadow-md p-6" data-id="element-349">
                <p className="text-gray-600 mb-4" data-id="element-350">
                  I'm currently available for:
                </p>
                <ul className="space-y-2" data-id="element-351">
                  <li className="flex items-center text-gray-700" data-id="element-352">
                    <span className="h-2 w-2 bg-green-500 rounded-full mr-2" data-id="element-353"></span>
                    Full-time product leadership roles
                  </li>
                  <li className="flex items-center text-gray-700" data-id="element-354">
                    <span className="h-2 w-2 bg-green-500 rounded-full mr-2" data-id="element-355"></span>
                    Product strategy consulting
                  </li>
                  <li className="flex items-center text-gray-700" data-id="element-356">
                    <span className="h-2 w-2 bg-green-500 rounded-full mr-2" data-id="element-357"></span>
                    Speaking engagements
                  </li>
                  <li className="flex items-center text-gray-700" data-id="element-358">
                    <span className="h-2 w-2 bg-yellow-500 rounded-full mr-2" data-id="element-359"></span>
                    Mentoring and advisory roles (limited availability)
                  </li>
                </ul>
              </div>
            </div>
            {/* Contact Form */}
            <div className="animate-fade-in" style={{
            animationDelay: '0.2s'
          }} data-id="element-360">
              <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-361">
                Send Me a Message
              </h2>
              <ContactForm data-id="element-362" />
            </div>
          </div>
        </div>
      </section>
      {/* Map Section */}
      <section className="py-16 bg-white" data-id="element-363">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-364">
          <h2 className="text-2xl font-bold text-gray-900 mb-6 animate-on-scroll" data-id="element-365">
            My Location
          </h2>
          <div className="h-96 bg-gray-300 rounded-lg overflow-hidden shadow-md animate-on-scroll" style={{
          animationDelay: '0.15s'
        }} data-id="element-366">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d206674.13079763647!2d-78.96444195!3d35.843768449999996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89ac5a2f9f51e0f7%3A0x6790b6528a11f0ad!2sRaleigh%2C%20NC%2C%20USA!5e0!3m2!1sen!2sin!4v1654145123456!5m2!1sen!2sin" width="100%" height="100%" style={{
            border: 0
          }} allowFullScreen={true} loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Raleigh-Durham area map" aria-label="Map showing Raleigh-Durham area in North Carolina" data-id="element-367"></iframe>
          </div>
        </div>
      </section>
    </div>;
};
export default ContactPage;